module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_i06.58d93bb4.svg";